export const SET_AREA = 'SET_AREA';
export const CLEAR_AREA = 'CLEAR_AREA';
